import React, { useEffect, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import logo from '../assets/images/logo.jpg';
import {
  Grid,
  List,
  Link,
  Container,
  ListItem,
  ListItemText,
  Typography,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { MdSearch, MdDehaze } from 'react-icons/md';
import PrimaryNavigation from './PrimaryNavigation';
import { useHistory } from 'react-router';
import { IoMdClose } from "react-icons/io";
const Header: React.FunctionComponent = (props: any) => {
  const [click, setClick] = useState(false);
  const [search, setSearch] = useState('');
  const history = useHistory();
  const [width, setWidth] = useState(window.innerWidth);
  const handleSearch = (event: React.MouseEvent<HTMLButtonElement>) => {
    setClick(!click);
  };
  const handleSearchVal = (event: any) => {
    setSearch(event.target.value);
    if (event.charCode === 13 || event.key == 'Enter') {
      window.open(`https://www.rainn.org/search/node/${search}`);
    }
  };
  const [navIcon, setNavIcon] = useState(false);
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
  }, []);
  const handleNavIcon = () => {
    setNavIcon(!navIcon);
  };

  return (
    <>
      <Typography component="div" className="centers-header header-with-mega-menu">
        <Container className="centers-donate mob-hide" maxWidth={false}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            spacing={0}
          >
            <Grid item>
              <a
                className="uppercase p-0 text-tc-1 font-bold block head-title mr-6"
                href="https://hotline.rainn.org/online?_ga=2.11974065.449650562.1637092225-1466333179.1632249051"
              >
                Get Help 24x7:
              </a>
            </Grid>
            <Grid item>
              {/* <div className="uppercase px-7 py-2 bg-sc-2 font-bold">
                call 800.656.hope (4673)
              </div> */}
              <Link
                href="https://rainn.org/about-national-sexual-assault-telephone-hotline?_ga=2.132242759.891802913.1636979794-1037315227.1636431899"
                className="uppercase px-7 py-2 text-tc-2 bg-sc-2 font-bold block main-button mr-4"
              >
                call 800.656.hope (4673)
              </Link>
            </Grid>
            <Grid item>
              <Link
                href="https://hotline.rainn.org/online?_ga=2.169235816.891802913.1636979794-1037315227.1636431899"
                className="uppercase px-7 py-2 text-tc-2 bg-sc-2 font-bold block main-button"
              >
                live chat
              </Link>
            </Grid>
          </Grid>
        </Container>

        {click && (
          <Typography
            component="div"
            className="centers-top-search search-input"
          >
            <IoMdClose className="close-icon" onClick={() => setClick(false)} />
            <TextField
              className="centers-banner-input w-full"
              placeholder="Search RAINN"
              name="search"
              value={search}
              onChange={handleSearchVal}
              onKeyPress={handleSearchVal}
            />
          </Typography>
        )}
        <Typography component="div" className="centers-menu">
          <Typography
            component="div"
            className="main-header-wrap centers-nav  "
          >
            <Typography
              component="div"
              className="flex items-center lg:justify-start justify-between"
            >
              <Link href="https://www.rainn.org/" className="brand-logo">
                <img src={logo} className="w-full" alt="rainn-logo" />
              </Link>
              <MdDehaze
                className="centers-menu-icon desktop-hide"
                onClick={handleNavIcon}
              />
            </Typography>
            <div className="flex ml-auto flex-wrap lg:flex-nowrap items-center">
              {window.innerWidth > 760 && (
                <>
                  <PrimaryNavigation user={props.user} {...props} />
                  <Button
                    onClick={handleSearch}
                    className="h-10 text-tc-1 font-bold search-icon "
                  >
                    <MdSearch className="text-2xl mx-2 " />
                  </Button>
                  <Link
                    href="https://give.rainn.org/a/donate-button"
                    className="main-button no-underline ml-2"
                  >
                    Donate
                  </Link>
                </>
              )}
              {navIcon && window.innerWidth <= 760 && (
                <>
                  <PrimaryNavigation />
                  <Link
                    href="https://give.rainn.org/a/donate-button"
                    className="main-button no-underline block my-2 min-w-full"
                  >
                    Donate
                  </Link>
                  <Typography component="div" className="w-full search-input my-3">
                    <p className="my-1">Search</p>
                    <TextField
                      className="centers-banner-input"
                      placeholder="Search RAINN"
                      name="search"
                      value={search}
                      onChange={handleSearchVal}
                      onKeyPress={handleSearchVal}
                    />
                  </Typography>
                </>
              )}
            </div>
          </Typography>
        </Typography>
      </Typography>
    </>
  );
};

export default Header;
